import { Image } from 'react-grid-gallery';

export interface CustomImage extends Image {
    original: string;
    tagStyle?: {
        width: number;
    };
}

export const customImages: CustomImage[] = [
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery20251%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery20251%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery20253%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery20253%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery20254%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery20254%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery20255%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery20255%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery20256%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery20256%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery20257%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery20257%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery20258%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery20258%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery20259%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery20259%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202510%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202510%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202511%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202511%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202512%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202512%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202513%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202513%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202514%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202514%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202515%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202515%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202516%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202516%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202517%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202517%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202518%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202518%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202519%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202519%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202520%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202520%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202521%401x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery202521%401x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/galleryDance1%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/galleryDance1%402x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/galleryDance7%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/galleryDance7%402x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/galleryDance2%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/galleryDance2%402x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/galleryDance8%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/galleryDance8%402x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/galleryDance9%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/galleryDance9%402x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/galleryDance10%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/galleryDance10%402x.jpg',
        width: 848,
        height: 616,
    },
    // animations
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/blackSet/3%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/blackSet/3%402x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/blackSet/33%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/blackSet/33%402x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/blackSet/44%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/blackSet/44%402x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/1%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/1%402x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/2%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/2%402x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/3%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/3%402x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/4%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/4%402x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/5%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/pinkSet/5%402x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/redSet/2%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/redSet/2%402x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/redSet/4%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/redSet/4%402x.jpg',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/redSet/5%402x.jpg',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/welcomeAnimPage/redSet/5%402x.jpg',
        width: 848,
        height: 616,
    },

    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery1%402x.png',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery1%402x.png',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery2%402x.png',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery2%402x.png',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery3%402x.png',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery3%402x.png',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery4Mob%402x.png',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery4Mob%402x.png',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery5Mob%402x.png',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery5Mob%402x.png',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery6%402x.png',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery6%402x.png',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery7%402x.png',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery7%402x.png',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery8%402x.png',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery8%402x.png',
        width: 848,
        height: 616,
    },
    {
        src: 'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery9%402x.png',
        original:
            'https://femme-general.s3.eu-north-1.amazonaws.com/section-gallery/gallery9%402x.png',
        width: 848,
        height: 616,
    },
];
